import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';
import { foldLocked, repeatTimes } from '../../utils/theFreaks';
import useFreaksT from './useFreaksT';
import { actionSx, freaksSx as s } from './freaksStyles';

// The context's real activities, from an everyday outing (tier 1) to a once-in-a-lifetime one (tier 10).
// "Repeat ×N" plays one several times in a row (as many as the energy allows, up to maxRepeat).
// Locked missions after the next one are folded away until "Show N locked missions".
export default function FreaksMissions({ missions, energy, disabled, maxRepeat = 0, onPlay }) {
  const { t } = useFreaksT();
  const [showLocked, setShowLocked] = useState(false);
  const { visible, hidden } = foldLocked(missions);
  return (
    <Box data-testid="freaks-missions">
      {(showLocked ? missions : visible).map((mission) => {
        const times = mission.locked ? 0 : repeatTimes(energy, mission.energy, maxRepeat);
        return (
          <Box key={mission.key} sx={{ ...s.card, ...s.between, opacity: mission.locked ? 0.55 : 1 }}>
            <Box sx={s.grow}>
              <Typography sx={{ ...s.small, ...s.muted }}>{t('theFreaks.missions.tier', { tier: mission.tier })}</Typography>
              <Typography sx={s.title}>{mission.name}</Typography>
              {mission.locked ? (
                <Typography sx={s.small}>🔒 {t('theFreaks.missions.locked', { respect: mission.unlockRespect })}</Typography>
              ) : (
                <>
                  <Typography sx={s.small}>
                    ⚡ {t('theFreaks.missions.energy', { energy: mission.energy })} · 🎯 {t('theFreaks.missions.chance', { chance: Math.round(mission.chance * 100) })}
                  </Typography>
                  <Typography sx={{ ...s.small, ...s.muted }}>
                    {t('theFreaks.missions.reward', { cash: mission.cash, respect: mission.respect })}
                  </Typography>
                </>
              )}
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 0.5 }}>
              <Button
                data-testid={`freaks-mission-${mission.key}`}
                disabled={disabled || mission.locked || energy < mission.energy}
                onClick={() => onPlay(mission)}
                sx={actionSx()}
              >
                {t('theFreaks.missions.go')}
              </Button>
              {times ? (
                <Button
                  data-testid={`freaks-mission-repeat-${mission.key}`}
                  disabled={disabled}
                  onClick={() => onPlay(mission, times)}
                  sx={{ minHeight: 36, textTransform: 'none', fontWeight: 700, color: DEFAULT_THEME_COLOR }}
                >
                  {t('theFreaks.missions.repeat', { times })}
                </Button>
              ) : null}
            </Box>
          </Box>
        );
      })}
      {hidden ? (
        <Button
          data-testid="freaks-missions-locked-toggle"
          onClick={() => setShowLocked(!showLocked)}
          sx={{ textTransform: 'none', fontWeight: 700, color: DEFAULT_THEME_COLOR }}
        >
          {showLocked ? t('theFreaks.missions.hideLocked') : t('theFreaks.missions.showLocked', { count: hidden })}
        </Button>
      ) : null}
    </Box>
  );
}
